// extracted by mini-css-extract-plugin
export default {"patientsChecklistContainer":"PatientsPreconfigCheckList_patientsChecklistContainer__sszQO","searchbarContainer":"PatientsPreconfigCheckList_searchbarContainer__dD8Ck"};